import { el, escape } from './dom';

export type LegalPageSection = {
  heading: string;
  /** Raw HTML — the legal copy is hand-authored so paragraphs / lists
   *  can include inline markup. Caller is responsible for trust here. */
  bodyHtml: string;
};

export type LegalPageProps = {
  heroH1: string;
  heroLede: string;
  /** Plain-language "last updated" date displayed in the hero. */
  lastUpdated: string;
  sections: readonly LegalPageSection[];
};

/**
 * Generic long-form static page used for /terms, /privacy, /refunds.
 * Re-uses the why-page layout so the typographic rhythm is consistent
 * with the rest of the site. Copy lives in routes.ts so changes don't
 * require a code review of the component.
 */
export const LegalPage = (props: LegalPageProps): HTMLElement => {
  const sectionsHtml = props.sections
    .map(
      (s) => `
      <section class="why-page-section">
        <h2>${escape(s.heading)}</h2>
        ${s.bodyHtml}
      </section>`,
    )
    .join('');
  return el(`
    <article class="why-page legal-page">
      <div class="container">
        <header class="why-page-header">
          <h1>${escape(props.heroH1)}<span class="accent-period">.</span></h1>
          <p class="why-page-lede">${escape(props.heroLede)}</p>
          <p class="legal-page-updated mono">last updated ${escape(props.lastUpdated)}</p>
        </header>
        ${sectionsHtml}
      </div>
    </article>
  `);
};
